/* unplugin-vue-components disabled */import { render } from "./PromocodeCampaignsModal.vue?vue&type=template&id=e4ff6eb4&ts=true"
import script from "./PromocodeCampaignsModal.vue?vue&type=script&lang=ts"
export * from "./PromocodeCampaignsModal.vue?vue&type=script&lang=ts"

import "./PromocodeCampaignsModal.vue?vue&type=style&index=0&id=e4ff6eb4&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__